import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AuthService } from '../../../../@core/auth/auth.service';
import { environment } from '../../../../../environments/environment';
import { BinTagBatchDTO } from '../models/bin-tag-batch-dto';
import { Observable } from 'rxjs';
import { PrinterDTO } from '../models/printer-dto';
import { BinTagType } from '../models/bin-tag-type';
import { BinTagDTO } from '../../pick-plan/models/bin-tag-dto';


@Injectable({
  providedIn: 'root'
})
export class BinTagService {
  protected basePath = '/';

  constructor(
    protected httpClient: HttpClient,
    private authService: AuthService
  ) {
    this.basePath = environment.PLATFORM_API_URL;
  }

  public getBinTagTypes(): Observable<BinTagType[]> {
    return this.httpClient.get<BinTagBatchDTO[]>(`${this.basePath}/api/binTagtypes`);
  }

  public getBinTagBatches(estimateId: number): Observable<BinTagBatchDTO[]> {
    let queryParameters = new HttpParams();

    queryParameters = queryParameters.set('estimateId', estimateId.toString());

    return this.httpClient.get<BinTagBatchDTO[]>(`${this.basePath}/api/BinTagBatches`,
      {
        params: queryParameters
      }
    );
  }

  public reprintBinTags(printerId: number, binTagIds: number[]) {
    let queryParameters = new HttpParams();

    queryParameters = queryParameters.append('printerId', printerId.toString());

    return this.httpClient.post<BinTagBatchDTO>(`${this.basePath}/api/BinTagBatches/reprintTags`, binTagIds,
      {
        params: queryParameters
      }
    );
  }

  public getBinTagBatch(binTagBatchId: number): Observable<BinTagBatchDTO[]> {
    return this.httpClient.get<BinTagBatchDTO[]>(`${this.basePath}/api/BinTagBatches/${binTagBatchId}`);
  }

  public postBinTagBatchDTO(binTag: BinTagBatchDTO): Observable<BinTagBatchDTO> {
    return this.httpClient.post<BinTagBatchDTO>(`${this.basePath}/api/BinTagBatches`, binTag);
  }

  public reprintBinTagBatch(id: number): Observable<any> {
    return this.httpClient.post<BinTagBatchDTO>(`${this.basePath}/api/BinTagBatches/reprint/${id}`, '');
  }

  public putBinTagBatchDTO(binTag: BinTagBatchDTO): Observable<BinTagBatchDTO> {
    return this.httpClient.put<BinTagBatchDTO>(`${this.basePath}/api/BinTagBatches/${binTag.id}`, binTag);
  }

  public getPrinters(includeInactive: boolean = false): Observable<PrinterDTO[]> {
    return this.httpClient.get<PrinterDTO[]>(`${this.basePath}/api/Printers/`);
  }

  public deleteBinTagDTO(id: number): Observable<any> {
    return this.httpClient.delete(`${this.basePath}/api/BinTagBatches/${id}`);
  }

  public getBinTags(includeInactive: boolean = false) {

    let queryParameters = new HttpParams();

    if (includeInactive !== undefined && includeInactive !== null) {
      queryParameters = queryParameters.set('includeInactive', <any>includeInactive);
    }

    return this.httpClient.get<BinTagDTO[]>(`${this.basePath}/api/binTags`,
      {
        params: queryParameters,
      }
    );
  }

  public getBinTag(binTagId: number): Observable<BinTagDTO> {
    return this.httpClient.get<BinTagDTO>(`${this.basePath}/api/binTags/${binTagId}`);
  }

  public barcodeLookup(barcode: string): Observable<BinTagDTO> {
    return this.httpClient.get<BinTagDTO>(`${this.basePath}/api/binTags/barcodelookup/${barcode}`);
  }

  public postBinTag(binTag: BinTagDTO): Observable<BinTagDTO> {
    return this.httpClient.post<BinTagDTO>(`${this.basePath}/api/binTags`, binTag);
  }

  public putBinTagDTO(binTag: BinTagDTO): Observable<BinTagDTO> {
    return this.httpClient.put<BinTagDTO>(`${this.basePath}/api/binTags/${binTag.binId}`, binTag);
  }

  public deleteBinTag(id: number): Observable<any> {
    return this.httpClient.delete(`${this.basePath}/api/binTags/${id}`);
  }


}
